var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgEat24 = function SvgEat24(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 542,
    height: 238,
    viewBox: "0 0 542 238",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 238.039V5.78516H155.141V50.0234H50.6602V98.7773H139.93V143.012H50.6602V193.809H155.141V238.039H0Z",
    fill: "#CA202D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.617 161.34H315.281L289.316 79.0898L261.617 161.34ZM339.324 238.039L328.164 202.188H247.895L236.055 238.039H183.34L267.812 5.78516H307.5L391.984 238.039H339.324Z",
    fill: "#CA202D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.164 238.039V50.0234H372.973V5.78516H541.988V50.0234H482.809V238.039H432.164Z",
    fill: "#CA202D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 542,
    height: 238,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEat24, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eat24.587f305e.svg";
export { ForwardRef as ReactComponent };